import { IconButton, Tooltip } from '@mui/material';
import { useTheme } from '@mui/styles';
import {
    Delete as DeleteIcon,
    Ellipses as EllipsesIcon,
    Favorite as FavoriteIcon,
    Lock as LockIcon,
    Unlock as UnlockIcon
} from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import { ActionTypes, actionText } from '@tassat/ui-definitions';
import * as React from 'react';

import muiStyles from './styles';
import { MenuButtonProps } from './types';

const iconButton = (type) => {
    switch (type) {
        case ActionTypes.delete:
            return DeleteIcon;
        case ActionTypes.lock:
            return LockIcon;
        case ActionTypes.unlock:
            return UnlockIcon;
        case ActionTypes.favorite:
            return FavoriteIcon;
        case ActionTypes.un_favorite:
            return FavoriteIcon;
        case ActionTypes.more:
        case ActionTypes.show_actions:
            return EllipsesIcon;
        default:
            return EllipsesIcon;
    }
};

const createTooltip = (type: ActionTypes, tooltip?: ActionTypes) => {
    const switchType = tooltip || type;

    return actionText(switchType);
};

export default function ActionButtonComponent(props: MenuButtonProps) {
    const {
        className,
        type,
        toolTip,
        iconColor,
        viewBox,
        handleClick,
        active
    } = props;

    const Icon = React.useMemo(() => iconButton(type), [type]);
    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    return (
        <Tooltip
            disableInteractive
            title={createTooltip(type, toolTip)}
        >
            <IconButton
                className={`${classes.root} ${className} ${active && classes.active}`}
                onClick={handleClick}
            >
                <Icon
                    className={classes.icon}
                    iconColor={iconColor || theme?.app?.applicationColors.enumColors.grey || '#575756'}
                    viewBox={viewBox}
                />
            </IconButton>
        </Tooltip>
    );
}